<template>
  <div class="mx-auto my-2">
    <v-card color="basil">
      <v-card-title class="text-left justify-left py-6">
        Trainees
      </v-card-title>

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="tabItem in tabItems" :key="tabItem">
          {{ tabItem }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in tabItems" :key="tabItem">
          <existing-trainee v-if="tabItem == 'Trainees from HRA'"/>
          <new-trainee v-if="tabItem == 'Newly Registered Trainees'"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import {TraineeService} from "./trainees.service";
import {getUser} from "@/utils/helper";
import ExistingTrainee from "./existing-trainee/existing-trainee.vue";
import NewTrainee from "@/components/Trainees/new-trainee/new-trainee.vue";

export default {
  props: {
    fromRoute: String,
  },
  components: {
    NewTrainee,
    ExistingTrainee,
  },
  data() {
    return {
      loading: false,
      selected: false,
      items: [],
      title: "",
      hraOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      entries: [],
      CPD_ACTIVITIES: [],
      cpdActLoading: false,
      cpdActivity: null,
      search: null,
      filterTrainee: '',
      startMenu: false,
      newTraineeStartMenu: null,
      newTraineeEndMenu: null,
      startDate: '',
      date: '',
      newTraineesSearch: '',
      newTraineeStartDate: '',
      endMenu: false,
      endDate: '',
      newTraineeEndDate: '',
      searchTrainee: null,
      select: null,
      dialog: false,
      detailDialog: false,
      traineeNotFound: false,
      traineStatusIds: {passId: "", failId: ""},
      traineeStatus: [],
      headers: [
        {text: "Full Name", value: "person.fullName"},
        {text: "Gender", value: "person.gender"},
        // { text: "Birth Date", value: "person.birthdate" },
        // {
        //   text: "Profession",
        //   value: "person.employee_job_history.jobtitlename",
        // },
        {text: "License Number", value: "person.licenseNumber"},
        {text: "Tin Number", value: "person.tin"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      export_fields: {
        "First Name": "person.firstname",
        "Middle Name": "person.middlename",
        "Last Name": "person.lastname",
        Gender: "person.gender",
        // eslint-disable-next-line no-constant-condition
        "Course Name": "trainee_course" ? ("trainee_course.course" ? "trainee_course.course.courseName" : " ") : ("trainee_cat2_course.program" ? "trainee_cat2_course.program.courseTitleCat2" : " "),
        // eslint-disable-next-line no-constant-condition
        CEU: "trainee_course" ? ("trainee_course.course" ? "trainee_course.course.continualEducationUnit" : " ") : ("trainee_cat2_course.program" ? "trainee_cat2_course.program.ceu" : " "),
      },
      export_new_trainee_fields: {
        "First Name": "trainee.firstName",
        "Middle Name": "trainee.middleName",
        "Last Name": "trainee.lastName",
        phoneNumber: "trainee.phoneNumber",
        // eslint-disable-next-line no-constant-condition
        "Course Name": "new_trainees_course" ? ("new_trainees_course.course" ? "new_trainees_course.course.courseName" : " ") : ("newt_cat2_course.program" ? "newt_cat2_course.program.courseTitleCat2" : " "),
        // eslint-disable-next-line no-constant-condition
        CEU: "new_trainees_course" ? ("new_trainees_course.course" ? "new_trainees_course.course.continualEducationUnit" : " ") : ("newt_cat2_course.program" ? "newt_cat2_course.program.ceu" : " "),
      },
      trainees: [],
      showTable: false,
      trainee: null,
      tab: null,
      tabItems: ["Trainees from HRA", "Newly Registered Trainees"],
      newTraineesSelect: null,
      newTraineeCourseDialog: false,
      newTraineeNotFound: false,
      newTrainee: null,
      newTraineeItems: [],
      newTrainees: [],
      newTraineeSearch: null,
      searchNewTrainee: null,
      newTCourseDetailDialog: false,
      newTraineeheaders: [
        {text: "Full Name", value: "trainee.fullName"},
        {text: "Phone Number", value: "trainee.phoneNumber"},
        {text: "Gender", value: "trainee.gender"},
        {
          text: "Profession",
          value: "trainee.healthProfession.name",
        },
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      historyLoading: false,
      newTraineeLoading: false,
    };
  },
  watch: {
    search(val) {
      if (this.select && this.items.length > 0) return;
      val && val !== this.select && this.querySelections(val);
      if (val === null) {
        this.traineeNotFound = false;
      }
    },
    options: {
      handler() {
        this.fetchTraineeList();
      },
      deep: true,
    },
    hraOptions: {
      handler() {
        this.fetchTraineeList();
      },
      deep: true,
    },
    filterTrainee: function (val) {
      this.filterTrainee = val;
      this.fetchTraineeList();
    },
    startDate: function (val) {
      if (val == null) {
        this.startDate = ''
      } else {
        this.startDate = val;
        this.fetchTraineeList();
      }
    },
    endDate: function (val) {
      if (val == null) {
        this.endDate = ''
      } else {
        this.endDate = val;
        this.fetchTraineeList();
      }
    },
    newTraineesSearch: function (val) {
      this.newTraineesSearch = val;
      this.fetchNewTraineeCourseList();
    },
    newTraineeStartDate: function (val) {
      if (val == null) {
        this.newTraineeStartDate = ''
      } else {
        this.newTraineeStartDate = val;
        this.fetchNewTraineeCourseList();
      }
    },
    newTraineeEndDate: function (val) {
      if (val == null) {
        this.newTraineeEndDate = ''
      } else {
        this.newTraineeEndDate = val;
        this.fetchNewTraineeCourseList();
      }
    },
    select(val) {
      val != null
          ? ((this.dialog = true),
              (this.traineeNotFound = false),
              (this.trainee = val))
          : (this.dialog = false);

      this.dialog == true ? (this.title = "Assign Trainee Course") : null;
    },
    newTraineeSearch(val) {
      if (this.newTraineesSelect && this.newTraineeItems.length > 0) return;
      val &&
      val !== this.newTraineesSelect &&
      this.newTraineeQuerySelections(val);
      if (val === null) {
        this.newTraineeNotFound = false;
      }
    },
    newTraineesSelect(val) {
      val != null
          ? ((this.newTraineeCourseDialog = true),
              (this.newTraineeNotFound = false),
              (this.newTrainee = val))
          : (this.newTraineeCourseDialog = false);
    },
  },
  computed: {
    fields() {
      if (!this.select) return [];

      return this.select;
    },
    canCreateTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canCreate
      );
    },
    canEditTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canUpdate
      );
    },
    canViewTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canRead
      );
    },
  },
  async beforeMount() {
    if (this.fromRoute === "Back") {
      this.tab = 0;
    } else if (this.fromRoute === "Add") {
      this.tab = 1;
    } else {
      this.tab = 0;
    }
  },
  methods: {
    formatDate(item) {
      const date = new Date(item.birthdate);
      return date;
    },
    viewTrainee(item) {
      this.trainee = item;
      this.detailDialog = true;
      this.title = "Trainee's Course Detail";
    },
    viewNewTrainee(item) {
      this.newTrainee = item;
      this.newTCourseDetailDialog = true;
      this.title = "New Trainee's Course Detail";
    },
    goToTraineeRegistration() {
      this.$router.push({
        path: "/registerTrainee",
        name: "Register Trainee",
        params: {fromRoute: "Add"},
      });
    },
    goToTraineeHistory() {
      this.$router.push({
        path: "/registerTrainee",
        name: "Register Trainee",
        params: {fromRoute: "History"},
      });
    },
    closeDialog(isNewTrainee) {
      this.detailDialog = false;
      this.newTraineeCourseDialog = false;
      this.newTCourseDetailDialog = false;
      this.dialog = false;
      isNewTrainee ? this.fetchNewTraineeCourseList() : this.fetchTraineeList();
    },
    async querySelections(v) {
      this.loading = true;
      const params = {
        value: v,
      };
      const res = await TraineeService.searchTrainee(params);

      if (res.status === 200) {
        this.loading = false;
        this.items = res.data;

        if (v != null && this.items.length === 0) {
          this.traineeNotFound = true;
        }

        this.items.map((item) => {
          item.fullName =
              item.firstname + " " + item.middlename + " " + item.lastname;
        });
        return this.items;
      } else {
        this.loading = false;

        return this.items;
      }
    },
    async newTraineeQuerySelections(v) {
      this.loading = true;
      const params = {
        value: v,
      };
      const res = await TraineeService.searchNewTrainee(params);

      if (res.status === 200) {
        this.loading = false;
        this.newTraineeItems = res.data;

        if (v != null && this.newTraineeItems.length === 0) {
          this.newTraineeNotFound = true;
        }

        this.newTraineeItems.map((item) => {
          item.fullName =
              item.firstName + " " + item.middleName + " " + item.lastName;
        });
        return this.newTraineeItems;
      } else {
        this.loading = false;

        return this.newTraineeItems;
      }
    },
    async registerOrUpdateTrainee(trainee) {
      this.historyLoading = true;
      let res = null;

      if (trainee.editMode) {
        res = await TraineeService.update(trainee.id, trainee);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchTraineeList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
          this.historyLoading = false;
        } else {
          this.historyLoading = false;
          this.$toast.error("Unable to create trainee, please try again");
        }
      } else {
        res = await TraineeService.create(trainee);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchTraineeList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
          this.historyLoading = false;
        } else {
          this.historyLoading = false;
          this.$toast.error("Unable to create trainee, please try again");
        }
      }
    },
    async registerOrUpdateNewTrainee(trainee) {
      let res = null;

      if (trainee.editMode) {
        res = await TraineeService.updateNewTraineeCourse(trainee.id, trainee);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchNewTraineeCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create trainee, please try again");
        }
      } else {
        res = await TraineeService.createNewTraineeCourse(trainee);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchNewTraineeCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create trainee, please try again");
        }
      }
    },
    refreshTraineeDetail() {
      this.fetchTraineeList();
      this.fetchNewTraineeCourseList();
      this.fetchTraineeStatus();
    },
    async fetchTraineeStatus() {
      this.traineeStatus = await TraineeService.getTraineeStatus();
      this.traineeStatus.data.filter((e) => {
        this.traineStatusIds.passId =
            e.code == "PASS" ? e.id : this.traineStatusIds.passId;
        this.traineStatusIds.failId =
            e.code == "FAIL" ? e.id : this.traineStatusIds.failId;
      });
    },
    async fetchTraineeList() {
      this.historyLoading = true;
      console.log('here')
      // let dates={}
      // this.startDate!==''&&(dates.startDate=this.startDate);
      // this.endDate!==''&&(dates.endDate=this.endDate);

      const {page, itemsPerPage} = this.hraOptions;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      // this.nonAccCpd !== null && (searchParams += '&trainingCenterId=' + this.nonAccCpd);
      // this.nonAccName !== null && (searchParams += '&name=' + this.nonAccName);
      const res = await TraineeService.getHraTraineeAssignList(params);
      if (res.status === 200) {
        this.trainees = res.data;
      }
      this.historyLoading = false;
    },
    async fetchNewTraineeCourseList() {
      this.newTraineeLoading = true;
      let dates = {}
      this.newTraineeStartDate !== '' && (dates.startDate = this.newTraineeStartDate)
      this.newTraineeEndDate !== '' && (dates.endDate = this.newTraineeEndDate)
      const res = await TraineeService.getNewTraineeCourseListWP(
          this.newTraineesSearch,
          dates
      );
      if (res.status === 200) {
        this.newTrainees = res.data;
      }

      this.newTraineeLoading = false;
    },
    editTrainee(item) {
      this.dialog = true;
      this.trainee = item;
      this.title = "Edit Trainee's Course";
    },
    editNewTrainee(item) {
      this.newTraineeCourseDialog = true;
      this.newTrainee = item;
      this.title = "Edit New Trainee's Course";
    },
  },
};
</script>

<style scoped>
.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
